import { observeStickyEvents, unobserveStickyEvents, StickyEvent } from 'sticky-events'

// Add '.sticky-events' to sticky element in vue templates

export const addStickyBehaviors = () => {
  observeStickyEvents()
  const stickies = Array.from(document.querySelectorAll('.sticky-events'))
  console.log(stickies)

  stickies.forEach((sticky) => {
    sticky.addEventListener(StickyEvent.CHANGE, (event) => {
      sticky.classList.toggle('u-flex-i', event.detail.isSticky)
    })

    sticky.addEventListener(StickyEvent.STUCK, (event) => {
      console.log('stuck')
    })

    sticky.addEventListener(StickyEvent.UNSTUCK, (event) => {
      console.log('unstuck')
    })
  })
  unobserveStickyEvents()
}
